export default __webpack_public_path__ + "static/media/authentification.5c2c93d5.md";